export function GetSecret(t) {
  return new Promise((resolve, reject) => {
    t.getRestApi()
      .getToken()
      .then((secret) => {
        let isSetToken = decodeURIComponent(secret).replace(/"/g, "");
        resolve(isSetToken);
      })
      .catch((err) => {
        resolve(null);
      });
  });
}

export const getUserInfo = async (t) => {
  return GetSecret(t).then((secret) => {
    window.Trello.setToken(secret);
    const token = secret;

    return fetch(
      `https://api.trello.com/1/members/me?key=035539076201571631d2a69fa82de83d&token=${token}`
    )
      .then((response) => response.json())
      .then((data) => {
        return {
          name: data.fullName,
          email: data.email,
          image: data.avatarUrl,
          token,
        };
      })
      .catch((error) => {
        console.error(
          "Ocorreu um erro ao obter as informações do usuário:",
          error
        );
        throw error;
      });
  });
};

export const getAllCardsWithListNames = async (t, boardId) => {
  try {
    const secret = await GetSecret(t);
    window.Trello.setToken(secret);
    const token = secret;

    const listsResponse = await fetch(
      `https://api.trello.com/1/boards/${boardId}/lists?key=035539076201571631d2a69fa82de83d&token=${token}`
    );
    const listsData = await listsResponse.json();

    if (!listsData || listsData.length === 0) {
      //console.log("No lists found.");
      return [];
    }

    const listsMap = listsData.reduce((acc, list) => {
      acc[list.id] = list.name;
      return acc;
    }, {});

    const cardsResponse = await fetch(
      `https://api.trello.com/1/boards/${boardId}/cards?key=035539076201571631d2a69fa82de83d&token=${token}`
    );
    const cardsData = await cardsResponse.json();

    return cardsData.map((card) => ({
      id: card.id,
      name: card.name,
      desc: card.desc || "",
      labels: card.labels ? card.labels.map(label => label.name).join(", ") : "",
      members: card.idMembers ? card.idMembers.join(", ") : "",
      due: card.due ? new Date(card.due).toLocaleDateString() : "",
      startDate: card.start ? new Date(card.start).toLocaleDateString() : "",
      listName: listsMap[card.idList] || "",
    }));
  } catch (error) {
    //console.error("Ocorreu um erro ao obter os cartões ou listas:", error);
    throw error;
  }
};
